import { useEffect, useState } from "react";

export default function useScrollDetection(ref) {
  const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false);
  const [hasVerticalScroll, setHasVerticalScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      const el = ref.current;
      if (!el) return;

      setHasHorizontalScroll(el.scrollWidth > el.clientWidth);
      setHasVerticalScroll(el.scrollHeight > el.clientHeight);
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [ref]);

  return { hasHorizontalScroll, hasVerticalScroll };
}
